import { BrowserRouter as Router } from "react-router-dom";

//Third party
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";

// Internal
import { ThemeRoutes } from "./routes";
import { GlobalContext } from "./context";
import { queryClient } from "./api/queryClient";
import { isMaintenanceMode } from "./constants/maintenance.config";
import { MaintenancePage } from "./pages/MaintenancePage/MaintenancePage";
import "./App.scss";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

console.log = function () {};

// Polyfill for Object.groupBy. [https://algoright.sentry.io/issues/514459]
if (typeof (Object as any).groupBy === typeof undefined) {
  (Object as any).groupBy = (arr: any, callback: any) => {
    return arr.reduce((acc: any = {}, ...args: any) => {
      const key = callback(...args);
      acc[key] ??= [];
      acc[key].push(args[0]);
      return acc;
    }, {});
  };
}

function App() {
  const isDevMode = localStorage.getItem("devMode") === "true";
  if (!isDevMode && isMaintenanceMode()) {
    return <MaintenancePage />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalContext>
        <div className="app-container">
          <ToastContainer />
          <Router>
            <ThemeRoutes />
          </Router>
        </div>
      </GlobalContext>
    </QueryClientProvider>
  );
}

export default App;
